/* eslint one-var: [0]*/
/* eslint max-len: [0]*/
/* eslint max-lines: [0]*/
/* eslint max-params: [0]*/
/* eslint complexity: [0]*/
/* eslint no-multi-assign: [0]*/
/* eslint prefer-const: [0]*/
/* eslint consistent-return: [0] */

import Modernizr from 'modernizr';
import Barba from 'barba.js';
import Utils from '../utils/utils.js';
// require( '../lib/gsap/uncompressed/utils/SplitText.js' ); // eslint-disable-line

export default Barba.BaseView.extend( {
	namespace: 'template-veranstaltungen-uebersicht',
	onEnter() {
		// The new Container is ready and attached to the DOM.
		
		// this.initScrollMagic();
		
		if ( ! Utils.isMobile() ){
			this.initMousemoveOnHeadlines();
		}
	},

	onEnterCompleted() {
		// The Transition has just finished.
	},

	onLeave() {
		// A new Transition toward a new page has just started.
		
		// this.destroyScrollMagic();	
		
		if ( ! Utils.isMobile() ){	
			this.destroyMousemoveOnHeadlines();
		}
	},

	onLeaveCompleted() {
		// The Container has just been removed from the DOM.
	},

	/**
	 * Init | Mousemove on Headline
	 */
	initMousemoveOnHeadlines(){
		this.$headlines = jQuery( '.c-events-overview__title-inner' );

		const $headlinesMousearea = jQuery( '<span class="js--mousemove-area absolute top-0 left-0 w-full h-full"></span>' );
		
		this.$headlines.each( ( i, el ) => {
			const $el = jQuery( el ),
				$mouseArea = $headlinesMousearea.clone(),
				headlineSplitText = new SplitText( $el, { 
					type: 'words,chars',
					charsClass: 'js--title-char',
					wordsClass: 'js--title-word'
				} ),
				headlineChars = headlineSplitText.chars;			

			$el.append( $mouseArea );
		} );

		this.$headlines.find( '.js--mousemove-area' ).on( 'mouseenter mousemove mouseleave', jQuery.proxy( this.moveHeadlineOnMouse, this ) );
	},

	/**
	 * Destroy | Mousemove on Headline
	 */
	destroyMousemoveOnHeadlines(){
		this.$headlines.find( '.js--mousemove-area' ).off( 'mouseenter mousemove mouseleave', jQuery.proxy( this.moveHeadlineOnMouse, this ) );
	},

	/**
	 * On Mouse | Mousemove on Headline
	 */	
	moveHeadlineOnMouse( event ){
		const self = this;

		if ( event.type === 'mouseenter' ){
			self.moveHeadlineOnMouseEnter( event );
		} else if ( event.type === 'mousemove' ){
			self.moveHeadlineOnMouseMove( event );
		} else if ( event.type === 'mouseleave' ){
			self.moveHeadlineOnMouseLeave( event );
		}
	},

	/**
	 * On Mouse #ENTER# | Mousemove on Headline
	 */	
	moveHeadlineOnMouseEnter( event ){
		const self = this,
			$target = jQuery( event.target ),
			$parent = $target.parent(),
			$chars = $parent.find( '.js--title-char' );

		event.preventDefault();
		event.stopPropagation();
		
		this._mouseMoveCurrentHeadline = {
			$target,
			width: $target.width(),
			height: $target.height(),
			$chars
		};

		this._mousecache = {};
		this._mousecache.oldX = 0;
		this._mousecache.oldY = 0;
		this._mousecache.x = 0;
		this._mousecache.y = 0;
		this._mousecache.distanceXPosition = 0;
		this._mousecache.distanceYPosition = 0;
		this._mousecache.needForRAF = ! 0;
		
		this.moveHeadlineChars();
	},

	/**
	 * On Mouse #MOVE# | Mousemove on Headline
	 */
	moveHeadlineOnMouseMove( event ){
		event.preventDefault();
		event.stopPropagation();

		const elOffset = this._mouseMoveCurrentHeadline.$target.offset();
		const mouseX = event.pageX - elOffset.left - this._mouseMoveCurrentHeadline.width / 2;
		const mouseY = event.pageY - elOffset.top - this._mouseMoveCurrentHeadline.height / 2;
		
		this._mousecache.distanceXPosition = mouseX;
		this._mousecache.distanceYPosition = mouseY;
		
		this.moveHeadlineChars();
	},

	/**
	 * On Mouse #LEAVE# | Mousemove on Headline
	 */
	moveHeadlineOnMouseLeave( event ){
		var self = this;
		
		event.preventDefault();
		event.stopPropagation();
		
		this.moveHeadlineResetChars();
	},

	/**
	 * Swap Vars | Mousemove on Headline
	 */	
	moveHeadlineSwapVars(){
		this._mousecache.oldX = this._mousecache.x;
		this._mousecache.oldY = this._mousecache.y;
	},

	/**
	 * Move Chars | Mousemove on Headline
	 */	
	moveHeadlineChars( ){
		const self = this;
		const $chars = this._mouseMoveCurrentHeadline.$chars;

		var t = this._mousecache.distanceXPosition;
		this._mousecache.x = this._mousecache.x + .1 * ( t - this._mousecache.x );
		
		var e = this._mousecache.distanceYPosition;
		this._mousecache.y = this._mousecache.y + .1 * ( e - this._mousecache.y );		

		$chars.each( ( i, el ) => {
			const $el = jQuery( el ),
				diff = 0.0075,
				n = 1000 * i;

			let r = i % 2 === 0 ? self._mousecache.y : self._mousecache.y * -1;
			r = 0 === i || 3 === i ? .2 * r : r;
			
			gsap.set( el, {
				x: self._mousecache.x.toFixed( 2 ) * diff,
				y: r.toFixed( 2 ) * 0.1,
				z: n,
				rotation: self._mousecache.x * 0.15
			} );
		} );

		this.moveHeadlineSwapVars();
	},

	/**
	 * Reset | Mousemove on Headline
	 */		
	moveHeadlineResetChars( ){
		const $chars = this._mouseMoveCurrentHeadline.$chars;
		
		gsap.set( $chars, {
			x: 0,
			y: 0,
			z: 0,
			rotation: 0
		} );

		this._mousecache = null;
		this._mouseMoveCurrentHeadline = null;
	},
  
	initScrollMagic(){
		this.ScrollController = new ScrollMagic.Controller();
		this.initImgScrollReveal();
	},

	destroyScrollMagic(){
		this.ScrollController.destroy();
		this.ScrollController = null;
	},

	initImgScrollReveal(){
		const self = this,
			triggerHook = 0.7,
			$revealer = jQuery( '<div class="c-reveal absolute top-0 left-0 w-full h-full bg-theme-base"></div>' ),
			$konzerte = jQuery( '.c-events-overview--konzerte' ),
			$kino = jQuery( '.c-events-overview--kino' ),
			$theater = jQuery( '.c-events-overview--theater' ),
			$lesungen = jQuery( '.c-events-overview--lesungen' ),
			$familie = jQuery( '.c-events-overview--kind-familie' );

		const buildRevealLeftRightTl = ( $el, $revealEl ) => {
			const tl = gsap.timeline(),
				_$revealer = $revealEl.clone();
			
			if ( $el.hasClass( 'c-events-overview__link' ) ){
				_$revealer.removeClass( 'bg-theme-base' );
				gsap.set( _$revealer, {
					backgroundColor: 'white'
				} );
			}
				
			$el.append( _$revealer );
      
			tl.fromTo( _$revealer, 0.8, {
				x: '0%'
			}, {
				x: '100%'
			} );
      
			return tl;
		};
    
		const buildFadeTl = ( $el ) => {
			const tl = gsap.timeline();
      
			tl.fromTo( $el, 0.5, {
				autoAlpha: 0
			}, {
				autoAlpha: 1
			} );

			return tl;
		};

		// Konzerte
		$konzerte.find( '.c-events-overview__item-img' ).each( ( i, el ) => {
			const $el = jQuery( el );
			let tl;

			if ( i === 0 || i === 1 ){
				tl = buildRevealLeftRightTl( $el, $revealer );  

				new ScrollMagic.Scene( {
					triggerElement: $el.get( 0 ),
					triggerHook,
				} )
					.setTween( tl )
					.addTo( self.ScrollController );
			}
		} );

		// Kino
		const kinoRevealTl = buildRevealLeftRightTl( $kino.find( '.c-events-overview__link' ), $revealer.removeClass( '' ) );
		$kino.find( '.c-events-overview__link' ).addClass( 'overflow-hidden' );
		new ScrollMagic.Scene( {
			triggerElement: $kino.find( '.c-events-overview__link' ).get( 0 ),
			triggerHook: 0.9,
		} )
			.setTween( kinoRevealTl )
			.addTo( self.ScrollController );     
    
		// Theater
		$theater.find( '.c-events-overview__item-img' ).each( ( i, el ) => {
			const $el = jQuery( el );
			const tl = gsap.timeline();
      
			$el.append( '<div class="c-reveal absolute top-0 left-0 w-1/2 h-full bg-theme-base"></div>' );
			$el.append( '<div class="c-reveal absolute top-0 pin-r w-1/2 h-full bg-theme-base"></div>' );
      
			tl
				.fromTo( $el.find( '.c-reveal:first' ), 0.4, {
					x: '0%'
				}, {
					x: '-100%'
				}, 0 )
				.fromTo( $el.find( '.c-reveal:last' ), 0.4, {
					x: '0%'
				}, {
					x: '100%'
				}, 0 );

			new ScrollMagic.Scene( {
				triggerElement: $el.get( 0 ),
				triggerHook,
			} )
				.setTween( tl )
				.addTo( self.ScrollController );       
		} );
    
		// Lesungen
		const lesungenRevealTl = buildRevealLeftRightTl( $lesungen.find( '.c-events-overview__link' ), $revealer );
    
		$lesungen.find( '.c-events-overview__link' ).addClass( 'overflow-hidden' );
		new ScrollMagic.Scene( {
			triggerElement: $lesungen.find( '.c-events-overview__link' ).get( 0 ),
			triggerHook: 0.9,
		} )
			.setTween( lesungenRevealTl )
			.addTo( self.ScrollController );  
    
		$lesungen.find( '.c-events-overview__item-img' ).each( ( i, el ) => {
			const $el = jQuery( el );
			let tl;

			if ( i === 2 ){
				tl = buildRevealLeftRightTl( $el, $revealer );  

				new ScrollMagic.Scene( {
					triggerElement: $el.get( 0 ),
					triggerHook,
				} )
					.setTween( tl )
					.addTo( self.ScrollController );
			}
		} );

		// Familie
		const familieFadeTl = buildFadeTl( $familie.find( '.c-events-overview__link' ) );
		new ScrollMagic.Scene( {
			triggerElement: $familie.find( '.c-events-overview__link' ).get( 0 ),
			triggerHook: 0.9,
		} )
			.setTween( familieFadeTl )
			.addTo( self.ScrollController );    
	}
} );
